const DESKTOP_BREAKPOINT = 750;
const SHELL_OPEN_REQUEST_EVENT = 'menu-navigation-shell:request-open';
const SHELL_STATE_EVENT = 'menu-navigation-shell:state';

class DesktopMenuLauncher extends HTMLElement {
  #shellState = {
    activeL1Index: null,
    open: false,
  };

  connectedCallback() {
    this.addEventListener('click', this.#handleClick);
    document.addEventListener(SHELL_STATE_EVENT, this.#handleShellState);
    window.addEventListener('resize', this.#handleResize);
    this.#syncExpandedState();
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#handleClick);
    document.removeEventListener(SHELL_STATE_EVENT, this.#handleShellState);
    window.removeEventListener('resize', this.#handleResize);
  }

  #handleClick = (event) => {
    if (!(event.target instanceof Element)) {
      return;
    }

    const trigger = event.target.closest('[data-menu-shell-launcher]');

    if (!(trigger instanceof HTMLButtonElement) || !this.contains(trigger) || !this.#isDesktopViewport()) {
      return;
    }

    const index = Number.parseInt(trigger.dataset.menuIndex || '', 10);

    if (Number.isNaN(index)) {
      return;
    }

    event.preventDefault();

    // The shell owns the menu tree and open state; this controller only forwards the L1 index.
    document.dispatchEvent(
      new CustomEvent(SHELL_OPEN_REQUEST_EVENT, {
        detail: {
          index,
          trigger,
        },
      })
    );
  };

  #handleShellState = (event) => {
    if (!(event instanceof CustomEvent)) {
      return;
    }

    const activeL1Index = Number.parseInt(`${event.detail?.activeL1Index ?? ''}`, 10);

    this.#shellState = {
      activeL1Index: Number.isNaN(activeL1Index) ? null : activeL1Index,
      open: Boolean(event.detail?.open),
    };

    this.#syncExpandedState();
  };

  #handleResize = () => {
    this.#syncExpandedState();
  };

  #isDesktopViewport() {
    return window.innerWidth >= DESKTOP_BREAKPOINT;
  }

  #syncExpandedState() {
    const isDesktopShellOpen = this.#isDesktopViewport() && this.#shellState.open;

    this.querySelectorAll('[data-menu-shell-launcher]').forEach((button) => {
      if (!(button instanceof HTMLButtonElement)) {
        return;
      }

      const buttonIndex = Number.parseInt(button.dataset.menuIndex || '', 10);
      const isExpanded =
        isDesktopShellOpen &&
        !Number.isNaN(buttonIndex) &&
        buttonIndex === this.#shellState.activeL1Index;

      button.setAttribute('aria-expanded', `${isExpanded}`);
      button.toggleAttribute('data-shell-active', isExpanded);
    });
  }
}

if (!customElements.get('desktop-menu-launcher')) {
  customElements.define('desktop-menu-launcher', DesktopMenuLauncher);
}